import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How does Strive Motors get paid?",
    a: "Our pricing is transparent and built into the vehicle price you see · no hidden markups or surprise fees.",
  },
  {
    q: "How long does it take to find my car?",
    a: "Timelines vary by vehicle, but most requests are matched within 24 hours. We keep you updated throughout the search.",
  },
  {
    q: "What if you can't find my exact car?",
    a: "We'll show you the closest available matches and keep searching, or help you adjust your budget or preferences.",
  },
  {
    q: "Is every vehicle inspected?",
    a: "Yes. Every vehicle we present is reviewed and verified before you see it. If something small comes up after delivery, we fix it · 28-day guarantee.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 lg:py-40 px-6 lg:px-10 bg-[#0A0A0A] border-t border-[#1c1c1c]">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-baseline gap-4 mb-14">
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#E31E24]">
            (07) · Questions
          </span>
          <span className="flex-1 h-px bg-white/15 mt-1" />
        </div>

        <div className="grid grid-cols-12 gap-10 lg:gap-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="col-span-12 lg:col-span-5 font-anton uppercase leading-[0.9] text-[10vw] md:text-[7vw] lg:text-[5vw]"
          >
            Straight <span className="font-cormorant italic font-medium text-[#E31E24]">answers.</span>
          </motion.h2>

          <div className="col-span-12 lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-t border-white/15 border-b-0 last:border-b last:border-white/15"
                >
                  <AccordionTrigger className="py-7 hover:no-underline hover:text-[#E31E24] text-left">
                    <div className="flex items-baseline gap-6 w-full">
                      <span className="font-mono2 text-white/50 text-xs">
                        0{i + 1}
                      </span>
                      <span className="font-anton uppercase text-xl lg:text-3xl leading-tight flex-1">
                        {f.q}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-7 pl-10 text-white/70 text-[15px] lg:text-base leading-relaxed max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
